//@ts-expect-error no types for this module
import {THEME_VARIANTS} from '@apps-common/ui-theme/Constants.js';
//@ts-expect-error no types for this module
import {createPlanetTheme} from '@apps-common/ui-theme/Themes.js';
import {type Theme} from '@mui/material/styles';
import {componentOverrides} from './overrides.ts';

export const theme = createPlanetTheme({
  colorScheme: THEME_VARIANTS.DARK,
  extendedConfig: {
    cssVariables: {
      disableCssColorScheme: true,
    },
    colorSchemes: {
      light: {
        palette: {
          DataGrid: {
            headerBg: 'grey.300',
          },
          magic: {
            start: '#0E9E5A',
            stop: '#0589A1',
            gradient: 'linear-gradient(to right, #0E9E5A, #0589A1)',
          },
        },
      },
      dark: {
        palette: {
          DataGrid: {
            headerBg: '#23343F',
          },
          magic: {
            start: '#61EA97',
            stop: '#00CBE5',
            gradient: 'linear-gradient(to right, #61EA97, #00CBE5)',
          },
        },
      },
    },
    components: componentOverrides,
  },
}) as Theme;
